import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

export const useOnInboxButtonClick = () => {
    const inboxWidget = useAppSelector(prop('inboxWidget'));

    return useCallback((): void => {
        const { inbox, chat } = window.Communication?.API || {};

        if (!inbox || !inboxWidget.enabled) {
            return;
        }

        const status = inbox.getWindowStatus() || {};

        if (status.close) {
            return inbox.showInboxTab();
        }

        if (status.hide) {
            chat?.minimize?.();

            return inbox.maximize();
        }
    }, [inboxWidget]);
};
